<template>
    <div class="rich-text-viewer">
        <ul>
            <li v-for="(item, index) in showList" :key="index">
                <div v-if="item.type === 'text'" v-html="item.value"></div>
                <div v-if="item.type === 'image'">
                    <img :src="item.value">
                </div>
                <div v-if="item.type === 'border'" class="rich-text-viewer-border"></div>
            </li>
        </ul>
    </div>
</template>

<script type="text/javascript">
/**
 * 富文本查看器
 * 
 * @prop list {array} 富文本列表数据
 */
export default {
    name: "richTextViewer",
    components: {},
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {};
    },
    computed: {
        showList () {
            return this.list.map(el => {
                if(el.type === 'text') {
                    let reg = new RegExp("\n", "g");
                    el.value = el.value.replace(reg, "<br/>");
                }
                return el;
            })
        }
    },
    methods: {},
    created() {},
    mounted() {}
}
</script>
<style lang="scss">

.rich-text-viewer {
    height: 700px;
    width: 468px;
    overflow-x: hidden;
    overflow-y: scroll;
    padding: 24px;
    background: #fff;
    border: 1px solid rgba(226, 226, 226, 1);

    li {
        padding-bottom: 24px;
        color: $text-color-black-85;
        @include pxAndLh(16);
    }

    &-border {
            &::before {
                content: '';
                display: block;
                width: 100%;
                border-top: 1px dashed rgba(0, 0, 0, 0.15);
            }
        }
}
</style>